import React, { createContext, useEffect, useState } from 'react'

export const ThemeContext = createContext()

export const ThemeProvider = ({ children }) => {
    const storedTheme = localStorage.getItem('theme') || 'light'
    const [theme, setTheme] = useState(storedTheme)

    const changeTheme = (themeType) => {
        setTheme(themeType)
        localStorage.setItem('theme', themeType)
    }

    useEffect(() => {
        // Apply theme class to <html> for global styles
        document.documentElement.className = theme === 'dark' ? 'app dark' : 'app light'
    }, [theme])

    return (
        <ThemeContext.Provider value={{ theme, changeTheme }}>
            {children}
        </ThemeContext.Provider>
    )
}
